<script>
  export default {
    props: {
      relatorio: {
        type: Array,
        required: true,
      }
    },
    methods: {
      formatarValor(valor) {
        return valor ? this.$options.filters.formatarNumero(valor) : '---';
      },
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <dl class="col-xs-4">
        <dt>Projeto</dt>
        <dd>{{ relatorio[0].nomeProjeto }}</dd>
      </dl>
      <dl class="col-xs-4">
        <dt>Data protocolo</dt>
        <dd>{{ relatorio[0].dataProtocolo | formatarData }} as {{ relatorio[0].horaProtocolo }}</dd>
      </dl>
      <dl class="col-xs-4">
        <dt>Nº Protocolo</dt>
        <dd>{{ relatorio[0].numeroProtocolo }}</dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-4">
        <dt>Nº Ofício</dt>
        <dd>{{ relatorio[0].numeroOficioProtocolo || '---' }}</dd>
      </dl>
      <dl class="col-xs-4">
        <dt>Nome Beneficiário</dt>
        <dd>{{ relatorio[0].nomeBeneficiarioProtocolo || '---' }}</dd>
      </dl>
      <dl class="col-xs-4">
        <dt>Valor (R$)</dt>
        <dd>{{ formatarValor(relatorio[0].valorProtocolo) }}</dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-6">
        <dt>Descrição</dt>
        <dd>{{ relatorio[0].descricaoProtocolo || '---' }}</dd>
      </dl>
      <dl class="col-xs-6">
        <dt>Observação</dt>
        <dd>{{ relatorio[0].observacaoProtocolo || '---' }}</dd>
      </dl>
    </div>

    <div class="table-responsive" v-if="relatorio.length > 1 || !!relatorio[0].idProtocoloHistorico">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th>Data</th>
          <th>Local destino</th>
          <th>Evento</th>
          <th>Usuário de origem</th>
          <th>Usuário de destino</th>
          <th>Observação</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in relatorio">
          <td>{{ item.dataHistorico | formatarData }} as {{ item.horaHistorico }}</td>
          <td>{{ item.nomeLocalDestino }}</td>
          <td>{{ item.nomeEvento }}</td>
          <td>{{ item.nomeUsuarioOrigem || '---' }}</td>
          <td>{{ item.nomeUsuarioDestino }}</td>
          <td>{{ item.observacaoHistorico || '---' }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/ProtocolosConteiner.vue